/**
 * SEO Configuration for AcquireFlow
 * Centralized SEO metadata for consistent optimization
 */

export const seoConfig = {
  // Site Information
  siteName: 'AcquireFlow',
  siteUrl: 'https://acquireflow.com', // Update with actual domain
  defaultTitle: 'AcquireFlow - Automate Your MLS Offers with AI',
  titleTemplate: '%s | AcquireFlow',
  defaultDescription:
    'Send 1,000+ automated MLS offers daily with AI-powered targeting. AcquireFlow helps real estate investors triple their deal volume without additional work.',

  // Keywords
  keywords: [
    'real estate automation',
    'MLS offers',
    'real estate investing',
    'property investment software',
    'automated offers',
    'real estate AI',
    'deal flow automation',
    'property acquisition',
    'real estate wholesaling',
    'investment property software',
  ],

  // Social Media
  social: {
    twitter: '@acquireflow', // Update with actual handle
    facebook: 'acquireflow', // Update with actual page
    linkedin: 'company/acquireflow', // Update with actual company
  },

  // Open Graph
  ogImage: 'https://acquireflow.com/og-image.jpg', // Update with actual image
  ogImageWidth: 1200,
  ogImageHeight: 630,

  // Twitter Card
  twitterCard: 'summary_large_image',
  twitterImage: 'https://acquireflow.com/twitter-card.jpg', // Update with actual image

  // Organization Schema
  organization: {
    name: 'AcquireFlow',
    url: 'https://acquireflow.com',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mWrZcYtRDkuuJnVj5p5E1s/AcquireFlow_Logo_%288%29.png',
    description:
      'AI-powered real estate investment automation platform helping investors send automated MLS offers and triple their deal volume.',
    foundingDate: '2024',
    contactPoint: {
      contactType: 'Customer Support',
      email: 'support@acquireflow.com', // Update with actual email
    },
  },

  // Product Schema
  product: {
    name: 'AcquireFlow',
    description:
      'Automated MLS offer platform for real estate investors. Send 1,000+ offers daily with AI-powered targeting.',
    category: 'Real Estate Software',
    offers: {
      core: {
        name: 'Core Plan',
        price: '497',
        priceCurrency: 'USD',
        priceValidUntil: '2026-12-31',
      },
      pro: {
        name: 'Pro Plan',
        price: '997',
        priceCurrency: 'USD',
        priceValidUntil: '2026-12-31',
      },
      scale: {
        name: 'Scale Plan',
        price: '1597',
        priceCurrency: 'USD',
        priceValidUntil: '2026-12-31',
      },
    },
  },

  // FAQ Schema Data
  faqSchema: [
    {
      question: 'How does AcquireFlow work?',
      answer:
        'AcquireFlow automates your entire MLS offer process using AI. It searches MLS listings, filters for motivated sellers, and sends personalized offers automatically.',
    },
    {
      question: 'How many offers can I send per day?',
      answer:
        'Core plan includes 1,500 offers/month, Pro includes 4,500 offers/month, and Scale offers unlimited automated offers.',
    },
    {
      question: 'How quickly can I get started?',
      answer:
        "Once you sign up, you'll book a 1-on-1 setup call with our team. We'll get you fully configured and sending offers within hours of your call.",
    },
    {
      question: 'What markets does AcquireFlow support?',
      answer: 'All plans include unlimited markets across the United States.',
    },
  ],
} as const

export type SEOConfig = typeof seoConfig
